export const COLLECTOR_SERVICE = '/collector/rest/collect-js';
